import cx from 'classnames';
import * as React from 'react';

enum Headings {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
}

type SectionHeaderProps = {
  /**
   * the html tag that you want the header to be, default to 'h2'
   *
   * @deprecated use renderContainer instead
   */
  as?: Headings;
  /**
   * render props that provide you the additional props to your component.
   */
  renderContainer?: (injectedProps: Omit<JSX.IntrinsicElements['h1'], 'ref'>) => JSX.Element;
} & JSX.IntrinsicElements['h1'];

/**
 * `SectionHeader` is the header for a `Section` component. By default it will renders a `h2` tag.
 * If you wish to render other html tags, use `renderContainer` props.
 */
export const SectionHeader = ({
  className,
  as: Component,
  renderContainer = (props) => <h2 {...props} />,
  ...props
}: SectionHeaderProps) =>
  Component ? (
    <Component className={cx('Section-header', className)} {...props} />
  ) : (
    renderContainer({
      ...props,
      className: cx('Section-header', className),
    })
  );
